import React, {
  useState,
} from 'react';
import { useStateContext } from '../../../hooks/useStateContext';
import { FileUploader } from 'react-drag-drop-files';
import { userByRole } from '../../../schema/userByRole';
import api from '../../../services/api';
import Box from '@mui/material/Box';
import { toaster } from '../../../services/toaster';
import CircularProgress from '@mui/material/CircularProgress';

export const UploadProfilePicture = ({
  setProfilePicture,
  uploading,
}: {
  setProfilePicture: (url: any) => void;
  uploading: (value: any) => void;
}) => {
  const fileTypes = ['JPG', 'PNG', 'GIF'];
  const [userSchema, setUserSchema] = useState(userByRole('1'));
  const [loading, setLoading] = useState(false);

  const { user } = useStateContext();
  const handleChange = (newFile: any) => {
    setLoading(true);
    uploading(true);
    newFile.preview = URL.createObjectURL(newFile);

    let formData = new FormData();
    const salesPartnerRoles: any = [];
    formData.append(`profile_picture`, newFile);

    api
      .postFile(`/upload-profile-picture`, formData)
      .then((res: any) => {
        setProfilePicture(res);
        toaster.show({
          intent: 'success',
          message: `Successfully uploaded profile picture`,
        });
      })
      .finally(() => {
        setLoading(false);
        uploading(false);
      });
  };

  return (
    <>
      <Box
        sx={{
          pointerEvents: loading ? 'none' : 'auto',
          opacity: loading ? 0.8 : 1,
        }}
      >
        <FileUploader
          multiple={false}
          handleChange={handleChange}
          name="file"
          types={fileTypes}
          classes={'w-full !max-w-[100%]'}
        />
        {loading && <CircularProgress size={10} />}
      </Box>
    </>
  );
};
